// extracted by mini-css-extract-plugin
module.exports = {"h3":"DeclarationHeader-module__h3___pR2oB","edit-icon":"DeclarationHeader-module__edit-icon___2Wxrn","editIcon":"DeclarationHeader-module__edit-icon___2Wxrn"};